
/** --------------------------------------------------------------------------------------------------
 * 開啟'確認刪除'視窗
 *
 *
 * @param message 要顯示的訊息
 * @param btn_yes 要顯示在 yes/ok 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param btn_no  要顯示在 no/cancel 按鈕的文字; 給 null 將不會顯示此按鈕
 * @param title   標題文字
 * @param observer function 當使用者點選'是'或'否'後,會呼叫的 function;
 *                 使用者點選'btn_yes'會回傳 true;
 *                 使用者點選'btn_no'會回傳 false;
 * @param type    類型 "warning", "error", "success" , "info"
 *
 * -------------------------------------------------------------------------------------------------- */
window.confirmDialog = function (message, btn_yes, btn_no, title, observer, type) {
    let btn_yes_n = (btn_yes !==undefined && btn_yes !== null && btn_yes !=='') ? btn_yes : '確定';
    let type_n    = (type ==undefined || type == null || type =='') ? 'info' : type;

    let setting = {
        title: title,
        text: message,
        icon: type_n,
        confirmButtonColor:'#4c55c3',
        cancelButtonColor:'#73899b',
    };

    setting.confirmButtonText = btn_yes_n;

    if(btn_no !== undefined && btn_no !== null && btn_no !== '' ){
        setting.cancelButtonText = btn_no;
        setting.showCancelButton = true;
    }
    if(observer){
        Swal.fire(setting)
            .then((result) => {

                observer(result.isConfirmed);
            });
    }else{
        Swal.fire(setting)
    }
}
